const requiredEnv = [
  "REACT_APP_SERVER_URL",
  "REACT_APP_GOOGLE_MAP_API_KEY",
  "REACT_APP_OTHER_USER_ACCESS_DOMAIN",
  // "REACT_APP_IMAGE_BASE_URL",
  // "REACT_APP_SOCKET_SERVER_URL",
  // "REACT_APP_EXCEL_VIEW_URL_PREFIX",
  // "REACT_APP_S3_ENR_BIOLERPLATE_URL",
  // "REACT_APP_ENABLE_SOCKET",
  // "REACT_APP_TITLE",
  // "REACT_APP_SUB_TITLE",
  // "REACT_APP_HIDE_VENUE_CREATE",
  // "REACT_APP_GENERAL_LEADS_AUTH_KEY",
  // "REACT_APP_GENERAL_LEADS_SOURCE_COMPANY_NAME",
  // "REACT_APP_VARIANT",
];

requiredEnv.forEach((key) => {
  if (!process.env[key]) {
    throw new Error(`❌ Missing environment variable: ${key}`);
  }
});

export {};